import { render, staticRenderFns } from "./Typography3.vue?vue&type=template&id=0b9f9460&scoped=true"
import script from "./Typography3.vue?vue&type=script&lang=js"
export * from "./Typography3.vue?vue&type=script&lang=js"
import style0 from "./Typography3.vue?vue&type=style&index=0&id=0b9f9460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9f9460",
  null
  
)

export default component.exports